/* --- Interactive --- */

const interactive = function (){
	const globe = document.getElementById('globe');
	if (globe == null) return;

	/* -- Variables -- */

		let svg, projection, path, width, height, scale, spinInterval;

		// URL of the GeoJSON of the world map
		const GeoJSON_URL = 'https://c24215cec6c97b637db6-9c0895f07c3474f6636f95b6bf3db172.ssl.cf1.rackcdn.com/interactives/2018/kim-jong-un/assets/world-110m.json';

		// US and NK
		// const US = [-98.585522, 39.8333333]; // Center of the continental USA
		// const US = [-77.0365298, 38.8976763]; // Washington DC
		// const NK = [130.46,42.26]; // Unggi
		const NK = [125.5, 39]; // P'yongyang

		// ISO code of countries
		const NorthKorea = 408;
		const UnitedStatesOfAmerica = 840;

		// Starting point for the globe that show both US and NK
		const startingPoint = [100, -70];//[155,-70];

		// Missile Range we want to show
		const missileRange = [
			// { name: 'Hwasong-9', range: 1600 },
			// { name: 'Hwasong-10', range: 4000 },
			// { name: 'Hwasong-12', range: 6000 },
			// { name: 'Hwasong-14', range: 10000, miles: 6000, target: [-110, 37] },
			{ name: 'Hwasong-15', range: 13000, miles: 8000, target: [-70, 24.5] }
		];

	/* -- Function -- */

		function isPointVisible(point) {
			const hasPath = path({type: 'Point', coordinates: point});
			return hasPath !== null ? true : false;
		}

		function getVisibleDimensions() {
			// Check the available screen real estate
			const visibleWidth = Math.floor(window.innerWidth * .9);
			const visibleHeight = Math.floor(window.innerHeight * .8);
			const containerWidth = document.querySelector('#globe').getBoundingClientRect().width;
			// console.log(`Width: ${visibleWidth}, Height: ${visibleHeight}`);

			// Return the smallest of all
			return Math.min(visibleWidth, visibleHeight, containerWidth);
		}

		function setProjection() {
			// Make the globe square
			width = getVisibleDimensions();
			height = width;
			scale = width/2*.97; // Make the scale fit 97% of the width

			// Size the SVG accordingly
			d3.select('#globe svg')
							.attr('width', width)
							.attr('height', height);

			// Select the planar projection for the sphere (earth)
			projection = d3.geoOrthographic()
										 .scale(scale)
										 .translate([width/2, height/2]) // center the map
										 .precision(.1)
										 .rotate(startingPoint);

			// Create the SVG path based on the selected projection
			path = d3.geoPath(projection);
		}

		function drawGlobe() {

			// Create the definition of the globe
			svg.append('defs').append('path')
					.datum({type: 'Sphere'})
					.attr('id', 'sphere')
					.attr('d', path)

			const g = svg.append('g').attr('class','globe');

			// Add the outline of the projection
			g.append('use')
				.attr('class', 'outline')
				.attr('xlink:href', '#sphere')

			// Add the background of the projection
			g.append('use')
				.attr('class', 'background')
				.attr('xlink:href', '#sphere')

			// Create the world graticule
			svg.append('g')
				.attr('class', 'graticule')
				.append('path')
				.datum(d3.geoGraticule())
				.attr('d', path);
		}

		function drawMap(geoJSON, interest) {
			// Add the countries based on the GeoJSON
			d3.json(geoJSON, function(error, world) {
				if (error) throw error;

				// Add MAP the the following path under the graticule
				const g = svg.insert('g', '.graticule').attr('class','map');

				// The countries
				const countries = topojson.feature(world, world.objects.countries).features;
				g.selectAll('.country')
					.data(countries).enter()
					.insert('path')
					.attr('d', path)
					.attr('class', function(d) {
						// Add a specific class fot the countries of interest
						return 'country' + (interest.indexOf(d.id) > -1 ? ' country--interest' : '');
					});
			});
		}

		function drawMissilesRange(origin,range) {

			let g = svg.select('.missiles');
			if (!g.size()>0) {
				g = svg.append('g').attr('class', 'missiles');
			}

			// Empty the element
			g.selectAll("*").remove();

			// Create a cicle centered on origin
			const missile = d3.geoCircle().center(origin);

			// Get the SVG circle based on the missile range center on North Korea Capital
			const getCircle = range => path(missile.radius(getRadius(range))());

			// Transform KM to radius based on earth circumference (40,075 Km)
			const getRadius = range => range/40075 * 360;

			// Get SVG Arc from target of the missile
			const getArc = function(target) {
				// Setup the data
				const start = projection(NK);
				const end = projection(target);

				// Calculate the radius
				const dx = end[0] - start[0];
				const dy = end[1] - start[1];
				const radius = Math.sqrt(dx*dx + dy*dy);

				// M start-x, start-y A radius-x, radius-y, x-axis-rotation, large-arc-flag, sweep-flag, end-x, end-y
				return `M ${start[0]}, ${start[1]} A ${radius}, ${radius}, 0, 0, 1, ${end[0]}, ${end[1]}`;
			}

			// Format number to decimal notation using comma for separation of thousands
			const format = d3.format(',d');

			// Add all the missiles
			g.selectAll('g')
					.data(range)
					.enter()
					.append('g')
						// Go trough each of the missiles
						.each(function(d){

							// Add a class to that missile for reference
							d3.select(this).attr('class', d.name);

							// Add the missile range to the globe
							d3.select(`.${d.name}`).append('path')
									.attr('class', 'range')
									.attr('d', getCircle(d.range));

							// Test if the Source or Target of the missiles is visible or not
							if(!isPointVisible(NK) || !isPointVisible(d.target)) return

							// Add the arc of the missile range
							d3.select(`.${d.name}`).append('path')
									.attr('class', 'arc')
									.attr('id', `arc-${d.range}`) // Something unique
									.attr('d', getArc(d.target));

							// Add arrow at the end of the target
							d3.select(`.${d.name}`).append('line')
									.attr('class', 'arrow')

							// Add the name of the missile ranges
							d3.select(`.${d.name}`).append('text')
								.attr('dy', '-.5em')
								.append('textPath')
									.attr('xlink:href', `#arc-${d.range}`) // The unique ID of the arc
									.attr('startOffset', '50%')
									.text(d=>format(d.miles)+' miles');
						})
		}

		function reDraw(globe=false) {
			// Select what to redraw
			let graphs = '.map path, .graticule path';

			// If we want to redraw the whole globe, not just the map
			graphs += globe ? ',#sphere' : '';

			// Redraw the map and the graticule
			d3.select('#globe').selectAll(graphs).attr('d', path);

			// Redraw the missiles range and the capitals
			drawMissilesRange(NK,missileRange);
		}

		function rotateGlobe() {
			const subject = function() {
				const current = projection.rotate();
				return { x: 2 * current[0], y: -2 * current[1] }
			};

			d3.select('#globe')
			  .call(
			  	d3.drag()
						.subject(subject)
						.on('drag', function() {
							clearInterval(spinInterval);
							// Change the projection based on the mouse drag
							projection.rotate([
								d3.event.x/2,
								-d3.event.y/2,
								projection.rotate()[2]
							]);

							reDraw(); // We just want to redraw the maps
						})
				);
		}

		// Rotate the globe by itself
		function spin() {
			const p = projection.rotate();
			projection.rotate([p[0] + .4, p[1] + .1, p[2] ]);
			reDraw(); // We just want to redraw the maps
		}

		// Spin the globe for 5 seconds when the user come to view with it
		function automaticSpin() {
			const top = globe.getBoundingClientRect().top;
			if (top <= window.innerHeight * 0.4 && top > 0) {
				spinInterval = window.setInterval(spin, 50);
				window.setTimeout(()=>clearInterval(spinInterval), 6000);
				window.removeEventListener('scroll', automaticSpin, false);
			}
		}

	/* -- Application -- */

		function app() {
			// Create the SVG container
			svg = d3.select('#globe').append('svg');

			// Calculate the Projection based on the current dimensions
			setProjection();

			// Create the globe
			drawGlobe();

			// Then add the graticule and the world map
			drawMap(GeoJSON_URL, [NorthKorea, UnitedStatesOfAmerica]);

			// Add arrows for the end of the missiles range
			svg.select('defs').append('marker')
				.attr('id', 'head')
				.attr('orient', 'auto')
				.attr('markerWidth', '2')
				.attr('markerHeight', '4')
	      .attr('refX', '0.1')
	      .attr('refY', '2')
	      .append('path')
	      	.attr('class', 'arrow')
	      	.attr('d', 'M0,0 V4 L2,2 Z');

			// Add the missiles range from a point of origin
			drawMissilesRange(NK,missileRange);

			// Add points of interest
			// pois = [NK,US];
			// drawPOI(pois);

			// Capabilty to drag the map
			rotateGlobe();

			// Spin the globe for 5 seconds when the user come to view with it
			window.addEventListener('scroll', automaticSpin, false);

			// If the screen is resized we reset the projection and redraw the globe
			window.addEventListener('resize', () =>{
				setProjection();
				reDraw(true); // We just want to redraw the whole globe
			}, false);
		}

	// Start the whole thing when the DOM is complete
	document.addEventListener('readystatechange', function() {
		document.readyState === 'complete' && app();
	}, false);

// end of the interactive
};
